function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getGetAppNavigationItemsQueryKey, getGetOrgNavigationItemsQueryKey, getGetProjNavigationItemsQueryKey, getGetUserPinsQueryKey, getProjectListQueryKey, pinNavigationItem, unpinNavigationItem } from 'ze-sdk';
export function usePinItem(projectListParams) {
    const queryClient = useQueryClient();
    const breadcrumbsQueryKey = getGetUserPinsQueryKey();
    return useMutation({
        mutationFn: async (value)=>{
            var _value_type;
            const { type } = value;
            const id = (_value_type = value[type]) === null || _value_type === void 0 ? void 0 : _value_type.id;
            if (!id) {
                throw new Error("Pin item missing id for type: ".concat(type));
            }
            const reqBody = {
                type,
                id
            };
            await pinNavigationItem(reqBody);
            return value;
        },
        onMutate: async (value)=>{
            var _ref, _ref1, _ref2;
            var _value_organization, _value_organization1, _value_project, _value_organization2, _value_project1;
            const queryOrganizationKey = getGetOrgNavigationItemsQueryKey({
                name: (_value_organization = value.organization) === null || _value_organization === void 0 ? void 0 : _value_organization.queryNameParam
            });
            const queryProjectKey = getGetProjNavigationItemsQueryKey({
                organization: (_ref = (_value_organization1 = value.organization) === null || _value_organization1 === void 0 ? void 0 : _value_organization1.name) !== null && _ref !== void 0 ? _ref : ''
            }, {
                name: (_value_project = value.project) === null || _value_project === void 0 ? void 0 : _value_project.queryNameParam
            });
            const queryAppKey = getGetAppNavigationItemsQueryKey({
                organization: (_ref1 = (_value_organization2 = value.organization) === null || _value_organization2 === void 0 ? void 0 : _value_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '',
                project: (_ref2 = (_value_project1 = value.project) === null || _value_project1 === void 0 ? void 0 : _value_project1.name) !== null && _ref2 !== void 0 ? _ref2 : ''
            });
            const queryKey = value.type === 'organization' ? queryOrganizationKey : value.type === 'project' ? queryProjectKey : queryAppKey;
            await queryClient.cancelQueries({
                queryKey
            });
            const navigationItems = queryClient.getQueryData(queryKey);
            const updatedNavigationItems = navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.map((item)=>{
                var _value_value_type;
                if (item.id === ((_value_value_type = value[value.type]) === null || _value_value_type === void 0 ? void 0 : _value_value_type.id)) {
                    return _object_spread_props(_object_spread({}, item), {
                        isPinned: true
                    });
                }
                return item;
            });
            queryClient.setQueryData(queryKey, updatedNavigationItems);
        },
        onSettled: async (data)=>{
            var _ref, _ref1, _ref2, _ref3;
            var _data_organization, _data_organization1, _data_project, _data_organization2, _data_project1, _data_organization3;
            if (!data) {
                return;
            }
            const queryOrganizationKey = getGetOrgNavigationItemsQueryKey({
                name: (_data_organization = data.organization) === null || _data_organization === void 0 ? void 0 : _data_organization.queryNameParam
            });
            const queryProjectKey = getGetProjNavigationItemsQueryKey({
                organization: (_ref = (_data_organization1 = data.organization) === null || _data_organization1 === void 0 ? void 0 : _data_organization1.name) !== null && _ref !== void 0 ? _ref : ''
            }, {
                name: (_data_project = data.project) === null || _data_project === void 0 ? void 0 : _data_project.queryNameParam
            });
            const queryAppKey = getGetAppNavigationItemsQueryKey({
                organization: (_ref1 = (_data_organization2 = data.organization) === null || _data_organization2 === void 0 ? void 0 : _data_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '',
                project: (_ref2 = (_data_project1 = data.project) === null || _data_project1 === void 0 ? void 0 : _data_project1.name) !== null && _ref2 !== void 0 ? _ref2 : ''
            });
            const queryKey = data.type === 'organization' ? queryOrganizationKey : data.type === 'project' ? queryProjectKey : queryAppKey;
            const projectListQueryKey = getProjectListQueryKey({
                organization: (_ref3 = (_data_organization3 = data.organization) === null || _data_organization3 === void 0 ? void 0 : _data_organization3.name) !== null && _ref3 !== void 0 ? _ref3 : ''
            }, projectListParams !== null && projectListParams !== void 0 ? projectListParams : {});
            await queryClient.invalidateQueries({
                queryKey
            });
            await queryClient.invalidateQueries({
                queryKey: projectListQueryKey
            });
            await queryClient.invalidateQueries({
                queryKey: breadcrumbsQueryKey
            });
        }
    });
}
export function useUnPinItem(projectListParams) {
    const queryClient = useQueryClient();
    const breadcrumbsQueryKey = getGetUserPinsQueryKey();
    return useMutation({
        mutationFn: async (value)=>{
            var _value_type;
            const { type } = value;
            const id = (_value_type = value[type]) === null || _value_type === void 0 ? void 0 : _value_type.id;
            if (!id) {
                throw new Error("Unpin item missing id for type: ".concat(type));
            }
            const reqBody = {
                type,
                id
            };
            await unpinNavigationItem(reqBody);
            return value;
        },
        onMutate: async (value)=>{
            var _ref, _ref1, _ref2;
            var _value_organization, _value_organization1, _value_project, _value_organization2, _value_project1;
            const queryOrganizationKey = getGetOrgNavigationItemsQueryKey({
                name: (_value_organization = value.organization) === null || _value_organization === void 0 ? void 0 : _value_organization.queryNameParam
            });
            const queryProjectKey = getGetProjNavigationItemsQueryKey({
                organization: (_ref = (_value_organization1 = value.organization) === null || _value_organization1 === void 0 ? void 0 : _value_organization1.name) !== null && _ref !== void 0 ? _ref : ''
            }, {
                name: (_value_project = value.project) === null || _value_project === void 0 ? void 0 : _value_project.queryNameParam
            });
            const queryAppKey = getGetAppNavigationItemsQueryKey({
                organization: (_ref1 = (_value_organization2 = value.organization) === null || _value_organization2 === void 0 ? void 0 : _value_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '',
                project: (_ref2 = (_value_project1 = value.project) === null || _value_project1 === void 0 ? void 0 : _value_project1.name) !== null && _ref2 !== void 0 ? _ref2 : ''
            });
            const queryKey = value.type === 'organization' ? queryOrganizationKey : value.type === 'project' ? queryProjectKey : queryAppKey;
            await queryClient.cancelQueries({
                queryKey
            });
            const navigationItems = queryClient.getQueryData(queryKey);
            const updatedNavigationItems = navigationItems === null || navigationItems === void 0 ? void 0 : navigationItems.map((item)=>{
                var _value_value_type;
                if (item.id === ((_value_value_type = value[value.type]) === null || _value_value_type === void 0 ? void 0 : _value_value_type.id)) {
                    return _object_spread_props(_object_spread({}, item), {
                        isPinned: false
                    });
                }
                return item;
            });
            queryClient.setQueryData(queryKey, updatedNavigationItems);
        },
        onSettled: async (data)=>{
            var _ref, _ref1, _ref2, _ref3;
            var _data_organization, _data_organization1, _data_project, _data_organization2, _data_project1, _data_organization3;
            if (!data) {
                return;
            }
            const queryOrganizationKey = getGetOrgNavigationItemsQueryKey({
                name: (_data_organization = data.organization) === null || _data_organization === void 0 ? void 0 : _data_organization.queryNameParam
            });
            const queryProjectKey = getGetProjNavigationItemsQueryKey({
                organization: (_ref = (_data_organization1 = data.organization) === null || _data_organization1 === void 0 ? void 0 : _data_organization1.name) !== null && _ref !== void 0 ? _ref : ''
            }, {
                name: (_data_project = data.project) === null || _data_project === void 0 ? void 0 : _data_project.queryNameParam
            });
            const queryAppKey = getGetAppNavigationItemsQueryKey({
                organization: (_ref1 = (_data_organization2 = data.organization) === null || _data_organization2 === void 0 ? void 0 : _data_organization2.name) !== null && _ref1 !== void 0 ? _ref1 : '',
                project: (_ref2 = (_data_project1 = data.project) === null || _data_project1 === void 0 ? void 0 : _data_project1.name) !== null && _ref2 !== void 0 ? _ref2 : ''
            });
            const queryKey = data.type === 'organization' ? queryOrganizationKey : data.type === 'project' ? queryProjectKey : queryAppKey;
            const projectListQueryKey = getProjectListQueryKey({
                organization: (_ref3 = (_data_organization3 = data.organization) === null || _data_organization3 === void 0 ? void 0 : _data_organization3.name) !== null && _ref3 !== void 0 ? _ref3 : ''
            }, projectListParams !== null && projectListParams !== void 0 ? projectListParams : {});
            await queryClient.invalidateQueries({
                queryKey
            });
            await queryClient.invalidateQueries({
                queryKey: projectListQueryKey
            });
            await queryClient.invalidateQueries({
                queryKey: breadcrumbsQueryKey
            });
        }
    });
}
